import * as tslib_1 from "tslib";
import { Query } from '@datorama/akita';
import { SessionStore } from './session.store';
import { map } from 'rxjs/operators';
var SessionQuery = /** @class */ (function (_super) {
    tslib_1.__extends(SessionQuery, _super);
    function SessionQuery(store) {
        var _this = _super.call(this, store) || this;
        _this.store = store;
        _this.loading$ = _this.select(function (_a) {
            var loading = _a.loading;
            return loading;
        });
        _this.user$ = _this.select(function (_a) {
            var user = _a.user;
            return user;
        });
        _this.topUnit$ = _this.user$.pipe(map(function (user) { return user.topUnits || []; }), map(function (arr) {
            return arr.slice().sort(function (a, b) { return a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1; });
        }));
        return _this;
    }
    SessionQuery.prototype.hasAuthority = function (authority) {
        return this.select(function (_a) {
            var user = _a.user;
            return !!user && user.authorities.includes(authority);
        });
    };
    SessionQuery.prototype.getCurrentUserId = function () {
        return Number(this.getValue().user.id);
    };
    return SessionQuery;
}(Query));
export { SessionQuery };
